import { render, staticRenderFns } from "./banner_left.vue?vue&type=template&id=8a370fde&scoped=true"
import script from "./banner_left.vue?vue&type=script&lang=js"
export * from "./banner_left.vue?vue&type=script&lang=js"
import style0 from "./banner_left.vue?vue&type=style&index=0&id=8a370fde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a370fde",
  null
  
)

export default component.exports